import { render, staticRenderFns } from "./ProductPrice.vue?vue&type=template&id=aa8ed140&scoped=true"
import script from "./ProductPrice.vue?vue&type=script&lang=js"
export * from "./ProductPrice.vue?vue&type=script&lang=js"
import style0 from "./ProductPrice.vue?vue&type=style&index=0&id=aa8ed140&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa8ed140",
  null
  
)

export default component.exports